import { push, LOCATION_CHANGE } from 'connected-react-router';
import { PAGE_NOTFOUND, setAppId, setAppVersion } from '../../youwell-common/fetchUtils';
import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper from '../../youwell-common/ReduxStoreHelper';

const ACTION_PREFIX = 'PAGESETTINGS';
const SET_PATH = 'PAGESETTINGS/SET_PATH';
const SET_VERSION = 'PAGESETTINGS/SET_VERSION';
const SET_CONFIG = 'PAGESETTINGS/SET_CONFIG';
const ADD_ORG_CONFIG = 'ADD_ORG_CONFIG';
const SET_CAL_DATE = 'SET_CAL_DATE';
const APPCONTENT_RECEIVED = 'APPCONTENT_RECEIVED';
const SET_PWA_STATUS = 'SET_PWA_STATUS';

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    setAppConfig: appConfig => (dispatch) => {
        setAppId(appConfig.appId);
        dispatch({ type: SET_CONFIG, appConfig });
    },

    setPath: path => (dispatch) => {
        const pathWithSlash = path && path[0] === '/' ? path : `/${path}`;
        dispatch({ type: SET_PATH, path: pathWithSlash });
    },

    setVersion: version => (dispatch) => {
        setAppVersion(version);
        dispatch({ type: SET_VERSION, version });
    },

    navigateTo: path => (dispatch) => {
        dispatch(push(path));
    },
    getOrgConfig: storeHelper.createGetElementActionCreator(`${apiUrls.app.public}/orgconfig`, ADD_ORG_CONFIG),
    setCalendarDate: date => (dispatch) => {
        dispatch({ type: SET_CAL_DATE, date });
    },
    getAppContent: storeHelper.createGetElementActionCreator(apiUrls.app.public, APPCONTENT_RECEIVED),
    setPwaStatus: pwaStatus => (dispatch) => {
        dispatch({ type: SET_PWA_STATUS, pwaStatus });
    },
};


const initialState = {
    pathname: '',
    version: '',
    newAvailableVersion: '',
    appConfig: {},
    orgConfig: {}, // This is duplicated in AuthStore (included in ProfileData). Should be merged..
    pageNotFound: false,
    calendarDate: new Date(),
    appContent: null,
    pwaStatus: null,
};

let prevPathname = '';

export const reducer = (state, action) => {
    switch (action.type) {
    case SET_CONFIG: {
        return {
            ...state,
            appConfig: action.appConfig || {},
        };
    }
    case SET_PATH: {
        return {
            ...state,
            pathname: action.path,
        };
    }
    case SET_VERSION: {
        return {
            ...state,
            version: action.version,
        };
    }
    case LOCATION_CHANGE: {
        const newState = {
            ...state,
            pageNotFound: false,
            prevPathname,
            pathname: action.payload.location.pathname,
        };
        prevPathname = newState.pathname;
        return newState;
    }
    case `${ACTION_PREFIX}/${ADD_ORG_CONFIG}`: {
        return {
            ...state,
            orgConfig: action.data || {},
        };
    }
    case PAGE_NOTFOUND: {
        return {
            ...initialState,
            pageNotFound: true,
        };
    }
    case SET_CAL_DATE: {
        return {
            ...state,
            calendarDate: action.date,
        };
    }
    case `${ACTION_PREFIX}/${APPCONTENT_RECEIVED}`: {
        return {
            ...state,
            appContent: action.data,
        };
    }
    case SET_PWA_STATUS: {
        return {
            ...state,
            pwaStatus: {
                ...state.pwaStatus,
                ...action.pwaStatus,
            },
        };
    }
    default: {
        return state || initialState;
    }
    }
};
